import config from "@/config";
import http from "@/utils/request";

export default {
	getUserList: {
		url: `${config.API_URL}/admin/user_lesson/getUserList`,
		name: "用户权限列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getLessonGoodsList: {
		url: `${config.API_URL}/admin/user_lesson/getLessonGoodsList`,
		name: "用户课程权限列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	getLessonGoodsListSearch: {
		url: `${config.API_URL}/admin/user_lesson/getLessonGoodsListSearch`,
		name: "用户课程权限商品搜索列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	addUserLesson: {
		url: `${config.API_URL}/admin/user_lesson/addUserLesson`,
		name: "新增用户权限",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	deleteUserLesson: {
		url: `${config.API_URL}/admin/user_lesson/deleteUserLesson`,
		name: "删除用户权限",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
};

